module.exports = __webpack_public_path__ + "img/back-title.f04bb51c.png";